"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initLogrocket = exports.BestowLogrocket = void 0;
var helpers_1 = require("./lib/helpers");
Object.defineProperty(exports, "BestowLogrocket", { enumerable: true, get: function () { return helpers_1.BestowLogrocket; } });
Object.defineProperty(exports, "initLogrocket", { enumerable: true, get: function () { return helpers_1.initLogrocket; } });
//# sourceMappingURL=index.js.map